export const toastsSelector = state => state.toasts.toasts;
